import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import NoDataImg from "../../../Assets/img/image 12.png";
import excel from "../../../Assets/img/vector/Vector (3).png";
import printer from "../../../Assets/img/vector/printer.png";

import { IoMdWallet } from "react-icons/io";
import { GiReceiveMoney } from "react-icons/gi";
import { GiMoneyStack } from "react-icons/gi";

import axios from "axios";
import { BASE_URL, IMAGE_URL, security_key } from "../../../global";
import DefaultAvatar from "./../../../Assets/img/avatar-default.jpeg";
import * as XLSX from "xlsx";

import { Button, Modal, Tab, Tabs } from "react-bootstrap";
import Tooltip from "@mui/material/Tooltip";

const EInfo = () => {
    const [payouts, setPayouts] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const userKey = sessionStorage.getItem("pk_user_key");
    const [row, setRow] = useState([]);
    const [show, setShow] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [userData, setUserData] = useState([]);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getAllPaymentData",
                user_key: sessionStorage.getItem("pk_user_key"),
            });
            const output = response.data;
            setPayouts(output);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const getUserData = async (key) => {
        var userKey = "";
        if (key == "payer") {
            userKey = row.payer_user_key && row.payer_user_key;
        } else if (key == "receiver") {
            userKey = row.receiver_user_key && row.receiver_user_key;
        } else {
            return;
        }
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                mode: "getUserData",
                pk_user_key: userKey,
            });
            const output = response.data;
            if (Object.keys(output).length > 0) {
                setUserData(output);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const getAmount = (row) => {
        if (row.payer_user_key == row.receiver_user_key) {
            return <span className="text-success">+${row.amount}</span>;
        } else if (row.payer_user_key == userKey) {
            return <span className="text-danger">-${row.amount}</span>;
        } else {
            return <span className="text-success">+${row.amount}</span>;
        }
    };
    const getPrintFormatAmount = (row) => {
        if (row.payer_user_key == row.receiver_user_key) {
            return `+$${row.amount}`;
        } else if (row.payer_user_key == userKey) {
            return `-$${row.amount}`;
        } else {
            return `+$${row.amount}`;
        }
    };

    // Function to handle Excel export
    const handleExcelExport = () => {
        const filteredPayouts = payouts.map((payout) => ({
            TransactionID: payout.transaction_id,
            AmountType: payout.currency,
            Amount: getPrintFormatAmount(payout),
            DateandTimeofTransaction: convertDateTime(payout.txn_date),
            Summary: payout.summary,
        }));

        const ws = XLSX.utils.json_to_sheet(filteredPayouts);

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Payouts");

        XLSX.writeFile(wb, "payouts.xlsx");
    };

    // Function to handle print functionality
    const handlePrint = () => {
        const printWindow = window.open("", "", "height=600,width=800");
        printWindow.document.write("<html><head><title>Print Payouts</title>");
        printWindow.document.write("</head><body>");

        // Create table to print
        printWindow.document.write("<h2>Payouts</h2>");
        printWindow.document.write(`
            <table border='1'>
                <tr>
                    <th>Transaction Id</th>
                    <th>Amont Type</th>
                    <th>Amount</th>
                    <th>Date and Time of Transaction</th>
                    <th>Summary</th>
                </tr>
        `);
        payouts.forEach((payout) => {
            printWindow.document.write(`
                <tr>
                    <td>${payout.transaction_id}</td>
                    <td>${payout.currency}</td>
                    <td>${getPrintFormatAmount(payout)}</td>
                    <td>${convertDateTime(payout.txn_date)}</td>
                    <td>${payout.summary}</td>
                </tr>
            `);
        });
        printWindow.document.write("</table>");
        printWindow.document.write("</body></html>");
        printWindow.document.close();
        printWindow.print();
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const filteredPayouts = useMemo(() => {
        handlePageChange(1);
        return payouts.filter((payout) => {
            const searchLower = searchTerm.toLowerCase();

            return (
                (payout.transaction_id && payout.transaction_id.toLowerCase().includes(searchLower)) ||
                (payout.currency && payout.currency.toLowerCase().includes(searchLower)) ||
                (payout.amount && `${payout.amount}`.toLowerCase().includes(searchLower)) ||
                (payout.txn_date && convertDateTime(payout.txn_date).toLowerCase().includes(searchLower)) ||
                (payout.summary && payout.summary.toLowerCase().includes(searchLower))
            );
        });
    }, [payouts, searchTerm]);

    const ITEMS_PER_PAGE = 10;

    const paginatedMagazines = useMemo(() => {
        const start = (currentPage - 1) * ITEMS_PER_PAGE;
        const end = start + ITEMS_PER_PAGE;
        return filteredPayouts.slice(start, end);
    }, [filteredPayouts, currentPage]);

    const totalPages = Math.ceil(filteredPayouts.length / ITEMS_PER_PAGE);

    const totalEarnings = payouts.reduce((sum, payout) => {
        const amount = parseFloat(payout.amount);
        if (amount > 0 && (payout.payer_user_key === payout.receiver_user_key || payout.payer_user_key !== userKey)) {
            return sum + amount;
        }
        return sum;
    }, 0);

    const requestPaid = payouts.reduce((sum, payout) => {
        const amount = parseFloat(payout.amount);
        const summary = payout.summary || "";

        if (amount > 0 && payout.payer_user_key === userKey && summary.toLowerCase() !== "test payment") {
            return sum + amount;
        }
        return sum;
    }, 0);

    const handleViewDetails = (row) => {
        setRow(row);
        handleShow(true);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
    };

    function convertDateTime(originalDateTime) {
        // Create a Date object from the original timestamp (assuming it's in UTC)
        let date = new Date(originalDateTime);

        // Adjust the date if necessary (e.g., use the following only if needed)
        // date.setDate(date.getDate() - 283); // Adjust days
        // date.setHours(date.getHours() - 8); // Adjust hours
        // date.setMinutes(date.getMinutes() - 23); // Adjust minutes

        // Format the date to '28 Jan 2024 11:05 AM' format
        const options = {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true, // Display 12-hour format
        };

        // Format the adjusted date
        return new Intl.DateTimeFormat("en-US", options).format(date).replace(",", "");
    }

    return (
        <>
            <section className="pb-3">
                <div className="main-content">
                    <h3 className="page-title">E-wallet</h3>
                    <div className="row g-2">
                        <div className="col-md-12 col-lg-3 px-2">
                            <div className="head-box p-3 d-flex">
                                <div className="icon-box bg-white rounded-3">
                                    <GiMoneyStack className="f-32" />
                                </div>
                                <div className="box px-2">
                                    <div className="text-box">
                                        <p>Total Earnings</p>
                                        {/* <span className="head-box-count">$650.00</span> */}
                                        <span className="head-box-count">${totalEarnings.toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-3 px-2">
                            <div className="head-box p-3 d-flex">
                                <div className="icon-box bg-white rounded-3">
                                    <GiReceiveMoney className="f-32" />
                                </div>
                                <div className="box px-2">
                                    <div className="text-box">
                                        <p>Total Paid Amount</p>
                                        <span className="head-box-count">${requestPaid.toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 px-2">
                            <div className="m-wrapper mt-3 p-3">
                                <div className="input-group mb-3 d-flex gap-3 align-items-center justify-content-between">
                                    <div className="net-input-field">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search"
                                            aria-label="Search"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                    <div className="net-input-field">
                                        <button
                                            className="btn btn-dark border border-dark ms-2 download-btn rounded-2"
                                            type="button"
                                            onClick={handleExcelExport}
                                        >
                                            <img src={excel} className="img-fluid pe-1 pb-1" alt="" />
                                            Excel
                                        </button>
                                        <button className="btn btn-dark border border-dark ms-2 download-btn rounded-2" type="button" onClick={handlePrint}>
                                            <img src={printer} className="img-fluid pe-1 pb-1" alt="" />
                                            Print
                                        </button>
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th className="bg-5">Transaction ID</th>
                                                <th className="bg-5">Amount Type</th>
                                                <th className="bg-5">Amount</th>
                                                <th className="bg-5">Date and Time of Transaction</th>
                                                <th className="bg-5">Summary</th>
                                                <th className="bg-5">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paginatedMagazines.length > 0 ? (
                                                paginatedMagazines.map((payout) => (
                                                    <tr key={payout.pk_pay_key}>
                                                        <td>{payout.transaction_id}</td>
                                                        <td>{payout.currency}</td>
                                                        {/* <td>${payout.amount}</td> */}
                                                        <td>{getAmount(payout)}</td>
                                                        {/* <td>{formatDate(payout.created_on)}</td> */}
                                                        <td>{convertDateTime(payout.txn_date)}</td>
                                                        <td>{payout.summary}</td>
                                                        <td>
                                                            <Tooltip title="View Details">
                                                                <Button variant="outline-dark" size="sm" onClick={() => handleViewDetails(payout)}>
                                                                    <i class="fa-sharp fa-solid fa-eye"></i>
                                                                </Button>
                                                            </Tooltip>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="6" className="text-center">
                                                        <div className="d-flex flex-column align-items-center">
                                                            <img src={NoDataImg} alt="No data" className="img-fluid" />
                                                            <span>No Data available</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    <div className="pagination d-flex justify-content-end mb-3 my-3">
                                        <Button onClick={() => handlePageChange(1)} disabled={currentPage === 1} className="btn btn-light mx-1">
                                            &lt;&lt;
                                        </Button>
                                        <Button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="btn btn-light mx-1">
                                            &lt;
                                        </Button>
                                        {Array.from({ length: totalPages }, (_, index) => (
                                            <Button
                                                key={index + 1}
                                                onClick={() => handlePageChange(index + 1)}
                                                className={`mx-1 ${currentPage === index + 1 ? "btn-dark text-white" : "btn-light"}`}
                                            >
                                                {index + 1}
                                            </Button>
                                        ))}
                                        <Button
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === totalPages}
                                            className="btn btn-light mx-1"
                                        >
                                            &gt;
                                        </Button>
                                        <Button
                                            onClick={() => handlePageChange(totalPages)}
                                            disabled={currentPage === totalPages}
                                            className="btn btn-light mx-1"
                                        >
                                            &gt;&gt;
                                        </Button>
                                    </div>
                                </div>

                                <Modal show={show} onHide={handleClose} size="lg">
                                    <Modal.Header closeButton>
                                        <Modal.Title>Payer & Receiver Details</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Tabs
                                            onSelect={(k) => getUserData(k)}
                                            defaultActiveKey="transaction"
                                            transition={false}
                                            id="noanim-tab-example"
                                            className="mb-3 border-0"
                                        >
                                            <Tab eventKey="transaction" title="Transaction" tabClassName="my-1">
                                                <p>
                                                    <strong>Transaction ID:</strong> {row.transaction_id && row.transaction_id}
                                                </p>

                                                <p>
                                                    <strong>Summary:</strong> {row.summary && row.summary}
                                                </p>
                                                <p>
                                                    <strong>Payer ID:</strong> {row.payer_id && row.payer_id}
                                                </p>
                                                <p>
                                                    <strong>Payer Email:</strong> {row.payer_email && row.payer_email}
                                                </p>

                                                {row.pk_sub_key && (
                                                    <>
                                                        <p>
                                                            <strong>Subscriped Plan:</strong> {row.sub_name}
                                                        </p>
                                                        <p>
                                                            <strong>Plan Validity:</strong>{" "}
                                                            {row.sub_month == 1 ? row.sub_month + " month" : row.sub_month + " months"}
                                                        </p>
                                                        <p>
                                                            <strong>Subscriped Date & Time:</strong> {convertDateTime(row.start_date)}
                                                        </p>
                                                        <p>
                                                            <strong>Renewable Date & Time:</strong> {convertDateTime(row.end_date)}
                                                        </p>
                                                    </>
                                                )}

                                                <p>
                                                    <strong>Receiver Email:</strong> {row.receiver_email && row.receiver_email}
                                                </p>
                                            </Tab>
                                            <Tab eventKey="payer" title="Payer Details" tabClassName="my-1">
                                                <div className="card p-3">
                                                    <div class="row">
                                                        <div class="col-md-4">
                                                            <div class="profile-img">
                                                                <img
                                                                    src={userData["profile_mod"] ? IMAGE_URL + userData["profile_mod"] : DefaultAvatar}
                                                                    // src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS52y5aInsxSm31CvHOFHWujqUx_wWTS9iM6s7BAm21oEN_RiGoog"
                                                                    alt="avatar"
                                                                    className="img-fluid w-100"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <Tabs defaultActiveKey="about" transition={false} id="noanim-tab-example" className="mb-3 d-flex">
                                                                <Tab eventKey="about" title="About" tabClassName="my-0 pb-3 mt-2 mb-0">
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>BIO</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["bio"] ? userData["bio"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>First Name</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["first_name"]}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Last Name</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["last_name"]}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>DOB</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["dob"] ? formatDate(userData["dob"]) : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Gender</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["gender"] == 1 ? "Male" : "Female"}</p>
                                                                        </div>
                                                                    </div>
                                                                </Tab>
                                                                <Tab eventKey="contact" title="Contact" tabClassName="my-0 pb-3 mt-2 mb-0">
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Email</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["user_email"]}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Phone</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["phone"] ? userData["phone"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>City</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["city"] ? userData["city"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>State</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["state"] ? userData["state"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Zip Code</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["zip_code"] ? userData["zip_code"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Address Line1</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["address_line1"] ? userData["address_line1"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Address Line2</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["address_line2"] ? userData["address_line2"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                </Tab>
                                                                <Tab eventKey="media" title="Social Media" tabClassName="my-0 pb-3 mt-2 mb-0">
                                                                    {/* <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Google+</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["google"] ? userData["google"] : "NA"}</p>
                                                                        </div>
                                                                    </div> */}
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Website</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["website"] ? userData["website"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Facebook</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["facebook"] ? userData["facebook"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Twitter</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["twitter"] ? userData["twitter"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Instagram</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["instagram"] ? userData["instagram"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Linkedin</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["linkedin"] ? userData["linkedin"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                </Tab>
                                                                {/* <Tab eventKey="timeline" title="Timeline"></Tab> */}
                                                            </Tabs>
                                                        </div>
                                                        {/* <div class="col-md-2"></div> */}
                                                    </div>
                                                </div>
                                            </Tab>
                                            <Tab eventKey="receiver" title="Receiver Details" tabClassName="my-1">
                                                <div className="card p-3">
                                                    <div class="row">
                                                        <div class="col-md-4">
                                                            <div class="profile-img">
                                                                <img
                                                                    src={userData["profile_mod"] ? IMAGE_URL + userData["profile_mod"] : DefaultAvatar}
                                                                    alt="avatar"
                                                                    className="img-fluid w-100"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <Tabs defaultActiveKey="about" transition={false} id="noanim-tab-example" className="mb-3">
                                                                <Tab eventKey="about" title="About" tabClassName="my-0 pb-3 mt-2 mb-0">
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>BIO</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["bio"] ? userData["bio"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>First Name</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["first_name"]}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Last Name</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["last_name"]}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>DOB</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["dob"] ? formatDate(userData["dob"]) : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Gender</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["gender"] == 1 ? "Male" : "Female"}</p>
                                                                        </div>
                                                                    </div>
                                                                </Tab>
                                                                <Tab eventKey="contact" title="Contact" tabClassName="my-0 pb-3 mt-2 mb-0">
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Email</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["user_email"]}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Phone</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["phone"] ? userData["phone"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>City</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["city"] ? userData["city"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>State</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["state"] ? userData["state"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Zip Code</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["zip_code"] ? userData["zip_code"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Address Line1</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["address_line1"] ? userData["address_line1"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Address Line2</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["address_line2"] ? userData["address_line2"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                </Tab>
                                                                <Tab eventKey="media" title="Social Media" tabClassName="my-0 pb-3 mt-2 mb-0">
                                                                    {/* <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Google+</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["google"] ? userData["google"] : "NA"}</p>
                                                                        </div>
                                                                    </div> */}
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Website</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["website"] ? userData["website"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Facebook</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["facebook"] ? userData["facebook"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Twitter</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["twitter"] ? userData["twitter"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Instagram</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["instagram"] ? userData["instagram"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col-md-6">
                                                                            <label>Linkedin</label>
                                                                        </div>
                                                                        <div class="col-md-6">
                                                                            <p>{userData["linkedin"] ? userData["linkedin"] : "NA"}</p>
                                                                        </div>
                                                                    </div>
                                                                </Tab>
                                                                {/* <Tab eventKey="timeline" title="Timeline"></Tab> */}
                                                            </Tabs>
                                                        </div>
                                                        {/* <div class="col-md-2"></div> */}
                                                    </div>
                                                </div>
                                            </Tab>
                                        </Tabs>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleClose}>
                                            Close
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                                <style jsx>
                                    {`
                                        .download-btn {
                                            width: 92px;
                                        }

                                        .net-input-field input,
                                        select {
                                            width: 252px !important;
                                            height: 42px;
                                            padding: 11px;
                                            border-radius: 4px;
                                            outline: none;
                                            transition: border-color 0.3s;
                                        }
                                        .w-90 {
                                            width: 90%;
                                        }
                                        .money-box {
                                            background-color: #d9d9d9 !important;
                                        }
                                        .money-box-count {
                                            font-weight: 600;
                                        }
                                    `}
                                </style>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default EInfo;
